module.exports = __webpack_public_path__ + "img/logo.d15da80a.png";